import React from 'react'
import { Container, Row, Col, Label, Input, Button } from 'reactstrap'
import { CustomAddon } from '../../model/Sign'
import { SquareInchPriceModalController } from './SquareInchPriceModalController'

class CustomAddonsModalController extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            model: CustomAddon.from(props.model),
        }
    }

    updateDescription(value) {
        const model = this.state.model
        model.description = value
        this.setState({
            'model': model
        })
    }

    updateSquareInch(value) {
        const model = this.state.model
        model.setSquareInchPrice(value)
        this.setState({
            'model': model
        })
    }

    updateUnitPrice(value) {
        const model = this.state.model
        model.setUnitPrice(value)
        this.setState({
            'model': model
        })
    }

    updateMarkUpPrice(value) {
        const model = this.state.model
        model.percent_marked_up = value
        this.setState({
            'model': model
        })
    }

    addButtonClicked() {
        const model = this.state.model
        model.parsePrice()
        this.props.addProccess(model)
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '20px',
                            'fontWeight': '500',
                        }}
                            >Process</Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Label>Description</Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Input
                            type="textarea"
                            value={this.state.model.description}
                            onChange={(e) => this.updateDescription(e.target.value)}
                            style={{'width': '100%', 'height': '350px'}}
                            />
                    </Col>
                </Row>
                <Row style={{'marginTop': '8px'}}>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label onClick={(e) => 
                                        this.props.showModal(
                                            <SquareInchPriceModalController
                                                model={this.state.model.square_inch_item_list}
                                                onUpdate={(items, total) => {
                                                    const newModel = this.state.model
                                                    newModel.square_inch_item_list = items
                                                    newModel.setSquareInchPrice(total.toFixed(2))
                                                    this.setState({
                                                        'model': newModel,
                                                    })
                                                }}
                                            />
                                        )
                                    }>Square Inch Price</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input
                                        value={this.state.model.getSquareInchPrice()}
                                        onChange={(e) => this.updateSquareInch(e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label onClick={(e) => 
                                        this.props.showModal(
                                            <SquareInchPriceModalController
                                                title={'Unit Price Calculator'}
                                                model={this.state.model.unit_item_list}
                                                onUpdate={(items, total) => {
                                                    const newModel = this.state.model
                                                    newModel.unit_item_list = items
                                                    newModel.setUnitPrice(total.toFixed(2))
                                                    this.setState({
                                                        'model': newModel,
                                                    })
                                                }}
                                            />
                                        )}>Unit Price</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input
                                        value={this.state.model.getUnitPrice()}
                                        onChange={(e) => this.updateUnitPrice(e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Percent Mark Up</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input
                                        value={this.state.model.percent_marked_up}
                                        onChange={(e) => this.updateMarkUpPrice(e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px'
                        }}
                            color='primary' onClick={(e) => this.addButtonClicked()}>Add</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { CustomAddonsModalController }

